import {
    useTranslate,
    Title
} from 'react-admin';
import {
    Grid,
    Box,
} from '@mui/material';
import { IncomeStatement } from '../Components/IncomeStatement';
import { DeviceChart } from '../Components/DeviceChart'
import React from 'react';
import { MemberDataCard } from '../Components/MemberDataCard';
import { SalesCard } from '../Components/SalesCard';
import { TitleCard } from '../Components/TitleCard';



// 主仪表盘组件
const Homepage = () => {
    const translate = useTranslate();
    const role = localStorage.getItem("permissions");
    const isAdminOrFinance = role === 'admin' || role === 'finance';

    if (!isAdminOrFinance) {
        return (
            <React.Fragment>
                <Title title={translate('pos.dashboard.title')} />
                <Box sx={{ flexGrow: 1, padding: 2 }}>
                    <h1>首页</h1>
                    <p>欢迎登录边缘计算平台</p>
                </Box>
            </React.Fragment>
        );
    }

    return (
        <React.Fragment>
            <Title title={translate('pos.dashboard.title')} />
            <Box sx={{ flexGrow: 1, marginBottom: '40px', width: '100%' }}>
                <Grid container spacing={2}>
                    <Grid item xs={12} sx={{ overflow: 'hidden' }}>
                        <TitleCard />
                    </Grid>
                    <Grid item xs={12} lg={6}>
                        <IncomeStatement />
                    </Grid>
                    <Grid item xs={12} lg={6}>
                        <DeviceChart />
                    </Grid>
                    <Grid item xs={12} lg={6}>
                        <MemberDataCard />
                    </Grid>
                    <Grid item xs={12} lg={6}>
                        <SalesCard />
                    </Grid>
                </Grid>
            </Box>
        </React.Fragment>
    );
};
export default Homepage;